export default {"src":"/_next/static/media/DOCX.a0673b87.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};